import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import waterSourceApi from '@/api/config/waterSourceApi'

function useSearchWaterSourceId(interfaceId: Number, id: number) {
  return useQuery({
    queryKey: [queryKeys.waterSource],
    queryFn: async () => {
      const { data } = await waterSourceApi.getById({ id })
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useSearchWaterSourceId